import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { JwtHelperService } from '@auth0/angular-jwt';
import { User } from '../services/model/types';
import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthservicesService {
  // errorImage = '../../assets/no1-preview.png';
  errorImage = 'assets/images/church.jpeg';
  pageSize = 10;
  pageNo;

  private currentUserSubject: BehaviorSubject<User>;
  private filterArr = new BehaviorSubject({});

  getFilterArr = this.filterArr.asObservable();
  baseUrl = environment.imgUrl;

  public currentUser: Observable<User>;
  constructor(
    private location: Location,
    public router: Router,
    private http: HttpClient,
    public afAuth: AngularFireAuth,
    public ngZone: NgZone
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('ministry_currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  setData(data) {
    this.filterArr.next(data);
  }
  goBack() {
    this.location.back();
  }

  createSkip(event, pageSize) {
    let skip = pageSize * (event - 1);
    return skip;
  }
  spilturl(image) {
    // let url = 'http://services.ravel.faith:9000/';
    let url = 'http://stage-api.ravel.faith:9000/';

    if (image == null || image == '') {
      return this.errorImage;
    } else {
      let imgarray = image.split('/');
      if ((imgarray[0] == 'http:') && (imgarray[2] == 'localhost:9000')) {
        const [baseUrl, imgUrl] = image.split('uploads');
        return `http://localhost:9000/uploads/${imgUrl}`
        // return image;
      } else if ((imgarray[0] == 'http:') && (imgarray[2] == 'stage-api.ravel.faith')) {
        return image
      }
      else {
        const [baseUrl, imgUrl] = image.split('uploads');
        return `https://services.ravel.faith/uploads/${imgUrl}`;
        // console.log('nnnnnnnnnnnnn',`https://services.ravel.faith/uploads${imgUrl}`)
        // return `${this.baseUrl}uploads${imgUrl}`
        // mainUrl = url + imgarray.join('/');
        // return mainUrl;
      }
    }
  }
  scrollToError(): void {
    setTimeout(() => {
      let firstElementWithError;

      firstElementWithError = document.querySelector('.invalid-feedback');

      firstElementWithError.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 0);
  }
  updateEmail(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/updateEmail`,
      data,
      options
    );
  }
  resendEmail(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/resendEmail`,
      data,
      options
    );
  }
  verifyEmail(data) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/common/verifyEmail`,
      data,
      options
    );
  }

  logout() {
    localStorage.removeItem('ministry_currentUser');
    this.currentUserSubject.next(null);
    this.router.navigateByUrl('/login');
  }

  geterrorImage(event) {
    event.target.src = this.errorImage;
  }
  loadImage(event, className) {
    event.path.forEach((element) => {
      if (element.className == className) {
        element.style = 'display:block';
      }
    });
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  getToken() {
    let token = 'Bearer ' + localStorage.getItem('ministry_token');
    return token;
  }

  successMessage(msg: string, type: 'success' | 'error' | 'info' | 'warning' | 'question' = 'success') {
    const isError = type === 'error';
    return Swal.fire({
      icon: type,
      title: msg,
      width: isError ? 520 : 480,
      padding: '1.25rem',
      background: isError ? '#0f172a' : '#ffffff',
      iconColor: isError ? '#ef4444' : undefined,
      confirmButtonText: isError ? 'Review' : 'OK',
      confirmButtonColor: isError ? '#3b82f6' : '#10b981',
      buttonsStyling: false,
      customClass: {
        popup: 'swal2-modern-popup',
        title: 'swal2-modern-title',
        confirmButton: 'btn btn-primary',
      },
      backdrop: isError
        ? 'rgba(2,6,23,0.7)'
        : 'rgba(0,0,0,0.4)',
      showClass: {
        popup: 'swal2-show',
        backdrop: 'swal2-backdrop-show',
      },
      hideClass: {
        popup: 'swal2-hide',
        backdrop: 'swal2-backdrop-hide',
      },
    });
  }

  OAuthProvider(provider) {
    return this.afAuth.auth
      .signInWithPopup(provider)
      .then((res) => {
        this.ngZone.run(() => {
          this.router.navigate(['profile']);
        });
      })
      .catch((error) => {
        window.alert(error);
      });
  }

  doFacebookLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new auth.FacebookAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        (res) => {
          console.log(res, 'res');
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }
  loginWithSocailMedia(data) {
    console.log(data, 'data');
    return this.http
      .post<any>(`${environment.baseUrl}/auth/socialLogin`, data)
      .pipe(
        map((user) => {
          console.log('userrrrrrrrrrrrrr', user);
          user = user.data;
          if (user && user.token) {
            const helper = new JwtHelperService();
            const decodedToken = helper.decodeToken(user.token);
            localStorage.setItem('ministry_token', user.token);
            localStorage.setItem('ministry_currentUser', JSON.stringify(decodedToken));
            this.currentUserSubject.next(user);
          }
          return user;
        })
      );
  }
  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.afAuth.auth.signInWithPopup(provider).then(
        (res) => {
          return resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  GetToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.afAuth.auth.onAuthStateChanged((user) => {
        if (user) {
          user.getIdToken().then((idToken) => {
            let userToken = idToken;
            resolve(userToken);
          });
        }
      });
    });
  }

  xAccessToeknHeader() {
    let headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    headers = headers.append('Authorization', this.getToken());
    headers.append('Origin', environment.baseUrl);
    let options = {
      headers: headers,
    };
    return options;
  }

  header() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: this.getToken(),
    });
    return headers;
  }

  getheaderwithoutauth() {
    const httpOptions = {
      headers: this.header(),
    };
    return httpOptions;
  }

  refreshToken() {
    this.refresh().subscribe(
      (res) => { },
      (error) => {
        console.log(error);
      }
    );
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: this.getToken(),
    });

    const httpOptions = {
      headers: headers,
      // params: { showLoader: 'yes' },
    };
    return httpOptions;
  }

  forgotPassword(data) {
    // let headers = new HttpHeaders().set("Authorization", "Bearer " + this.getToken());
    // let options = {
    //   headers: headers
    // };
    return this.http.post(
      `${environment.baseUrl}/auth/generateOTP`,
      data,
      this.getHeader()
    );
  }

  changePassword(data) {
    // let headers = new HttpHeaders().set(
    //   "Content-Type",
    //   "application/json; charset=utf-8"
    // );
    // let options = {
    //   headers: headers
    // };
    return this.http.post(
      `${environment.baseUrl}/auth/changePassword`,
      data,
      this.getHeader()
    );
  }

  signUp(obj) {
    return this.http.post<any>(`${environment.baseUrl}/auth/signup`, obj).pipe(
      map((user) => {
        user = user.data;
        if (user && user.token) {
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(user.token);
          localStorage.setItem('ministry_token', user.token);
          localStorage.setItem('ministry_currentUser', JSON.stringify(decodedToken));
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }
  login(obj) {
    return this.http.post<any>(`${environment.baseUrl}/auth/login`, obj).pipe(
      map((user) => {
        user = user.data;
        if (user && user.token) {
          localStorage.clear();
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(user.token);
          localStorage.setItem('ministry_token', user.token);
          localStorage.setItem('ministry_currentUser', JSON.stringify(decodedToken));
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  galleryApi(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/gallery?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  register(data) {
    return this.http.post(
      `${environment.baseUrl}/auth/signup`,
      data,
      this.getHeader()
    );
  }

  swal(title) {
    return Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${title} it!`,
    });
  }

  refresh() {
    return this.http.post(
      `${environment.baseUrl}/comman/refreshToken`,
      {},
      this.getHeader()
    );
  }

  getCommunityByid(id) {
    return this.http.get(
      `${environment.baseUrl}/community/getCommunitybyid/${id}`,
      this.getheaderwithoutauth()
    );
  }
  // api/comman/getfaiths?skip=0&limit=10

  getFaith(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/comman/getfaiths?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  getCommunity(skip, limit, search, query = null) {
    let url = `${environment.baseUrl}/community/getcommunity?skip=${skip}&limit=${limit}&search=${search}`
    if (query) {
      url = `${environment.baseUrl}/community/getcommunity?skip=${skip}&limit=${limit}&search=${search}&type=${query}`
    }
    return this.http.get(url,
      this.getHeader()
    );
  }

  addSocialLinks() {
    return this.http.get(
      `${environment.baseUrl}/comman/getTags`,
      this.getHeader()
    );
  }

  getAlerts(isMine, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/getAllALerts?isMine=${isMine}&skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  getEvents(isMine, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/events?skip=${skip}&limit=${limit}&mine=${isMine}`,
      this.getHeader()
    );
  }

  getCommunityEvents(isMine, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/communityEvents?skip=${skip}&limit=${limit}&mine=${isMine}`,
      this.getHeader()
    );
  }

  getEventsById(id) {
    return this.http.get(
      `${environment.baseUrl}/community/getEventById/${id}`,
      this.getHeader()
    );
  }
  getEventsFollowers(id) {
    return this.http.get(
      `${environment.baseUrl}/community/getEventById/${id}/followers`,
      this.getHeader()
    );
  }

  getEventswithoutLoader(isMine, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/events?skip=${skip}&limit=${limit}&mine=${isMine}`,
      this.getheaderwithoutauth()
    );
  }

  getDetailEvent(id) {
    return this.http.get(
      `${environment.baseUrl}community/getEventById/${id}`,
      this.getHeader()
    );
  }

  getPostCards(skip, limit, mine) {
    return this.http.get(
      `${environment.baseUrl}/community/getAllAnnouncement?skip=${skip}&limit=${limit}&mine=${mine}`,
      this.getHeader()
    );
  }

  getCommunityClaimList(data: any) {
    return this.http.post(
      `${environment.baseUrl}/user/search/community`,
      data,
      this.getHeader()
    );
  }

  getMerchantdirectory(skip, limit, search) {
    return this.http.get(
      `${environment.baseUrl}/user/search/merchant?skip=${skip}&limit=${limit}&search=${search}`,
      this.getHeader()
    );
  }

  onFilterMerchant(detail) {
    return this.http.post(
      `${environment.baseUrl}/user/search/merchant`,
      detail,
      this.getHeader()
    );
  }
  getDonations(skip, limit, status) {
    console.log("entered get donationsssssssss");
  return this.http.get(
    `${environment.baseUrl}/community/donations?skip=${skip}&limit=${limit}&status=${status}`,
    this.getHeader()
  );
}

  getCommunityClaimAffilation(data) {
    return this.http.post(
      `${environment.baseUrl}/community/claim/list`,
      data,
      this.getHeader()
    );
  }

  blockCommmunity(id) {
    return this.http.post(
      `${environment.baseUrl}/common/block/community/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  // unblockCommunity(id) {
  //   return this.http.post(
  //     `${environment.baseUrl}/common/unblock/community/${id}`, {},
  //     this.getheaderwithoutauth()
  //   );
  // }

  reportCommunity(id) {
    return this.http.post(
      `${environment.baseUrl}/user/report/community/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  reportMerchant(id) {
    return this.http.post(
      `${environment.baseUrl}/user/report/merchant/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }
  blockMerchant(id) {
    return this.http.post(
      `${environment.baseUrl}/common/block/merchant/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  blockUser(id) {
    return this.http.post(
      `${environment.baseUrl}/common/block/user/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  // unblockMerchant(id) {
  //   return this.http.post(
  //     `${environment.baseUrl}/common/unblock/merchant/${id}`, {},
  //     this.getheaderwithoutauth()
  //   );
  // }

  upload(data) {
    return this.http.post(`${environment.baseUrl}/comman/fileHandler`, data);
  }
  uploadFileUpload(formData) {
    let headers = new HttpHeaders().set('enctype', 'multipart/form-data');
    headers = headers.append('Authorization', this.getToken());
    let options = {
      headers: headers,
    };
    return this.http.post(
      `${environment.baseUrl}/comman/fileHandler`,
      formData,
      options
    );

    // return this.httpClient
    //   .post(`${environment.SERVER_URL}/api/${url}`, formData, options)
  }

  signUpBaseInfo(data) {
    return this.http.post(
      `${environment.baseUrl}/community/basicInfo`,
      data,
      this.getHeader()
    );
  }

  signUpAddress(data) {
    return this.http.post(
      `${environment.baseUrl}/community/addCommunityAddress`,
      data,
      this.xAccessToeknHeader()
    );
  }

  signUpSocialLinks(data) {
    return this.http.post(
      `${environment.baseUrl}/community/addSocialLink`,
      data,
      this.getHeader()
    );
  }

  signUpAboutus(data) {
    return this.http.post(
      `${environment.baseUrl}/community/addBiography`,
      data,
      this.getHeader()
    );
  }

  signUpCustomfieldtext(data) {
    return this.http.post(
      `${environment.baseUrl}/community/addcustomCategory`,
      data,
      this.getHeader()
    );
  }

  createAlerts(data) {
    console.log("dara>>>>>>", data)
    return this.http.post(
      `${environment.baseUrl}/community/alerts`,
      data,
      this.getHeader()
    );
  }

  createPostcards(data) {
    return this.http.post(
      `${environment.baseUrl}/community/announcement`,
      data,
      this.getHeader()
    );
  }

  claimCommunity(data) {
    return this.http.post(
      `${environment.baseUrl}/community/claimCommunity`,
      data,
      this.getHeader()
    );
  }

  createEvents(data) {
    return this.http.post(
      `${environment.baseUrl}/community/event`,
      data,
      this.getHeader()
    );
  }

  editEvent(data, id) {
    return this.http.put(
      `${environment.baseUrl}/community/event/${id}`,
      data,
      this.getHeader()
    );
  }

  deleteEvent(id) {
    return this.http.delete(
      `${environment.baseUrl}/community/deleteEvent/${id}`,
      this.getHeader()
    );
  }

  // -----------Post------------ //

  createPost(data) {
    return this.http.post(
      `${environment.baseUrl}/post/createPost`,
      data,
      this.getHeader()
    );
  }

  createComment(data, id) {
    return this.http.post(
      `${environment.baseUrl}/post/comment/${id}`,
      data,
      this.getheaderwithoutauth()
    );
  }
  getPost(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/post/getposts?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  getcommentById(skip, limit, id) {
    return this.http.get(
      `${environment.baseUrl}/post/${id}/comments?skip=${skip}&limit=${limit}`,
      this.getheaderwithoutauth()
    );
  }

  getPostbyId(id) {
    return this.http.get(
      `${environment.baseUrl}/post/getpostbyid/${id}`,
      this.getHeader()
    );
  }

  reportPost(id) {
    return this.http.post(
      `${environment.baseUrl}/post/reportPost/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }
  deletePost(id) {
    return this.http.delete(
      `${environment.baseUrl}/post/deletepostbyid/${id}`,
      this.getheaderwithoutauth()
    );
  }
  likePost(id) {
    return this.http.post(
      `${environment.baseUrl}/post/likepost/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  dislikePost(id) {
    return this.http.post(
      `${environment.baseUrl}/post/dislikepost/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }
  comment(id) {
    return this.http.post(
      `${environment.baseUrl}/post/comment/${id}`,
      this.getHeader()
    );
  }

  addSupport(data) {
    console.log("data>>>>>>>", data)
    return this.http.post(
      `${environment.baseUrl}/support`,
      data,
      this.getHeader()
    );
  }

  getSupport(skip, limit, status, role) {
    return this.http.get(
      `${environment.baseUrl}/support?skip=${skip}&limit=${limit}&status=${status}&role=${role}`,
      this.getHeader()
    );
  }

  getSupportId(id) {
    return this.http.get(
      `${environment.baseUrl}/support/${id}`,
      this.getHeader()
    );
  }

  addComment(data, id) {
    return this.http.post(
      `${environment.baseUrl}/support/${id}/comments`,
      { description: data },
      this.getheaderwithoutauth()
    );
  }

  getComment(id, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/support/${id}/comments?skip=${skip}&limit=${limit}`,
      this.getheaderwithoutauth()
    );
  }

  changeStatus(id, data) {
    return this.http.post(
      `${environment.baseUrl}/support/${id}/status`,
      { status: data },
      this.getheaderwithoutauth()
    );
  }

  getfaq(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/faq?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  communitydetails(id) {
    return this.http.get(
      `${environment.baseUrl}/community/getCommunitybyid/${id}`,
      this.getHeader()
    );
  }

  affilatedUserlist(skip, limit, userType) {
    return this.http.get(
      `${environment.baseUrl}/community/affiliatedUsersList/?skip=${skip}&limit=${limit}&userType=${userType}`,
      this.getHeader()
    );
  }


  followerList(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/followersList/?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }
  merchantFollowers(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/merchant/getfollowers/?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  getUnblockedList(url, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/${url}/?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  unblockUsers(url, id) {
    return this.http.post(
      `${environment.baseUrl}/common/${url}/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  getcommlList(id, skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/followersList/?id=${id}&skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  followUnfollow(url, id) {
    return this.http.post(
      `${environment.baseUrl}/community/${url}/${id}`,
      {},
      this.getheaderwithoutauth()
    );
  }

  addPartner(id: any) {
    return this.http.post(
      `${environment.baseUrl}/community/partnerRequest/${id}`,
      {},
      this.getHeader()
    );
  }

  removePartner(id: any, type: string = '') {
    let url = `${environment.baseUrl}/community/removePartner/${id}`
    if (type) {
      url = `${environment.baseUrl}/community/removePartner/${id}?listType=${encodeURIComponent(type)}`
    }
    return this.http.post(url, {}, this.getHeader());
  }

  addStaff(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/common/staff/?skip=${skip}&limit=${limit}`,
      this.getheaderwithoutauth()
    );
  }

  addStaffList(data) {
    return this.http.post(
      `${environment.baseUrl}/community/addStaff/`,
      data,
      this.getheaderwithoutauth()
    );
  }

  staffList(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/community/staffList/?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  updateStaff(data) {
    return this.http.put(
      `${environment.baseUrl}/community/updateStaff/`,
      data,
      this.getHeader()
    );
  }

  deleteStaff(data) {
    return this.http.post(
      `${environment.baseUrl}/community/archiveStaff`,
      data,
      this.getHeader()
    );
  }

  // Mentor APIs
  addMentor(communityId, data) {
    // API route: /api/community/mentor (communityId comes from auth context)
    return this.http.post(
      `${environment.baseUrl}/community/mentor`,
      data,
      this.getHeader()
    );
  }

  getMentorsByCommunity(communityId: string, skip: number = 0, limit: number = 10, search: string = '') {
    // API route: /api/community/:communityId/mentors?skip=0&limit=10&search=
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    return this.http.get(
      `${environment.baseUrl}/community/${communityId}/mentors?skip=${skip}&limit=${limit}${searchParam}`,
      this.getHeader()
    );
  }

  getMentorById(mentorId) {
    return this.http.get(
      `${environment.baseUrl}/mentor/${mentorId}`,
      this.getHeader()
    );
  }

  getMentors(mentorId) {
    return this.http.get(
      `${environment.baseUrl}/mentors`,
      this.getHeader()
    );
  }

  updateMentor(mentorId, data) {
    return this.http.put(
      `${environment.baseUrl}/mentor/${mentorId}`,
      data,
      this.getHeader()
    );
  }

  deleteMentor(mentorId) {
    return this.http.delete(
      `${environment.baseUrl}/mentor/${mentorId}`,
      this.getHeader()
    );
  }

  // Get users with pagination and search for mentor selection
  getUsersForMentor(skip: number, limit: number, search: string = '') {
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    return this.http.get(
      `${environment.baseUrl}/community/mentors/select?skip=${skip}&limit=${limit}&searchtype=selectmentor${searchParam}`,
      this.getHeader()
    );
  }

  getStaffType() {
    return this.http.get(
      `${environment.baseUrl}/common/staff`,
      this.getHeader()
    );
  }

  getnotifications(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/comman/getnotifications/?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  addBulltin(data) {
    return this.http.post(
      `${environment.baseUrl}/community/addBulletin/`,
      data,
      this.getHeader()
    );
  }

  getBulltin(id) {
    return this.http.get(
      `${environment.baseUrl}/community/bulletins?communityId=${id}`,
      this.getHeader()
    );
  }

  editBulltin(id, data) {
    return this.http.put(
      `${environment.baseUrl}/community/editBulletin/${id}`,
      data,
      this.getHeader()
    );
  }

  removeBulltin(id) {
    return this.http.delete(
      `${environment.baseUrl}/community/removeBulletin/${id}`,
      this.getHeader()
    );
  }

  addVideo(data) {
    return this.http.post(
      `${environment.baseUrl}/Community/addVideo`,
      data,
      this.getHeader()
    );
  }

  getVideo() {
    return this.http.get(
      `${environment.baseUrl}/Community/getVideos`,
      this.getHeader()
    );
  }

  editvideo(data) {
    return this.http.put(
      `${environment.baseUrl}/Community/updateVideo/`,
      data,
      this.getHeader()
    );
  }

  removeVideo(data) {
    return this.http.post(
      `${environment.baseUrl}/Community/deleteVideo/`,
      data,
      this.getHeader()
    );
  }

  communitySearch(data) {
    return this.http.post(
      `${environment.baseUrl}/user/search/community/`,
      data,
      this.getHeader()
    );
  }

  campusGreeting(data) {
    return this.http.post(
      `${environment.baseUrl}/community/welcomeMessage`,
      data,
      this.getHeader()
    );
  }

  getcampusGreeting() {
    return this.http.get(
      `${environment.baseUrl}/community/welcomeMessage`,
      this.getHeader()
    );
  }

  onphotoGallery(data) {
    return this.http.post(
      `${environment.baseUrl}/common/gallery`,
      data,
      this.getHeader()
    );
  }

  deleteGalleryImage(data) {
  return this.http.request(
    "DELETE",
    `${environment.baseUrl}/common/gallery`,
    {
      ...this.getHeader(),
      body: data,
    }
  );
}

  getPhotoGallery(skip, limit) {
    return this.http.get(
      `${environment.baseUrl}/gallery?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  getGalleryImages() {
    return this.http.get(
      `${environment.baseUrl}/common/gallery`,
      this.getHeader()
    );
  }

  getAllCommunityListing(skip: Number, limit: Number) {
    return this.http.get(
      `${environment.baseUrl}/admin/getAllCommunityType?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  getCommunityType(skip: Number, limit: Number) {
    return this.http.get(
      `${environment.baseUrl}/admin/getAllCommunityType?skip=${skip}&limit=${limit}`,
      this.getHeader()
    );
  }

  createLog(data: Object) {
    let options = this.getHeader();
    return this.http.post(
      `${environment.baseUrl}/common/activityLogUsers`,
      data,
      options
    );
  }

  acceptDeclinePartnerRequest(data: any) {
    return this.http.post(
      `${environment.baseUrl}/partnerRequest/status`,
      data,
      this.getHeader()
    );
  }

  getPartnerList(type: string = '') {
    let url = `${environment.baseUrl}/community/partnerList`;
    if (type) {
      url = `${environment.baseUrl}/community/partnerList?listType=${encodeURIComponent(type)}`;
    }
    return this.http.get(url, this.getHeader());
  }

  associationRequests(
    skip?: number,
    limit?: number,
    reqType: string = 'satellite'
  ) {
    const params = [];

    if (typeof skip === 'number') {
      params.push(`skip=${skip}`);
    }

    if (typeof limit === 'number') {
      params.push(`limit=${limit}`);
    }

    if (reqType) {
      params.push(`reqType=${reqType}`);
    }
    const qp = params.length ? `?${params.join('&')}` : '';
    return this.http.get(
      `${environment.baseUrl}/community/associationRequest${qp}`,
      this.getHeader()
    );
  }



  getAssociations(
    reqType: 'all' | 'headquarter' | 'satellite',
    skip = 0,
    limit = 10
  ) {
    return this.http.get<any>(
      `${environment.baseUrl}/community/associationRequest`,
      {
        params: {
          reqType: reqType,
          skip: skip.toString(),
          limit: limit.toString()
        },
        headers: this.getHeader().headers
      }
    );
  }






  associationRequestAction(associationId: string, actionType: 'approve' | 'reject' | 'remove') {
    const body = { associationId, actionType };
    return this.http.put(
      `${environment.baseUrl}/community/associationRequest`,
      body,
      this.getHeader()
    );
  }

  addAssociationRequest(headquartersId: string) {
    const safeId = (headquartersId || '').toString().trim();
    if (!safeId) {
      throw new Error('headquartersId is required');
    }
    return this.http.post(
      `${environment.baseUrl}/community/association`,
      { headquartersId: safeId },
      this.getHeader()
    );
  }
  getData(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      environment.baseUrl + url,
      this.getHeader()
    );
  }

  contactMessages(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}`,
      options
    );
  }
  getUserFollowing(url: String, params?: any) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}?skip=${params.skip}&limit=${params.limit}&type=${params.type}&search=${params.search}`,
      options
    );
  }
  getPostMessages(url: string) {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}${url}`,
      options
    );
  }

  postData(url: string, data: any) {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.getToken(),
      }),
    };
    return this.http.post(environment.baseUrl + url, data, headers);
  }

  /**
   * Activate the user profile
   */
  activateUser() {
    return this.http.post(
      `${environment.baseUrl}/user/activateUser`,
      {},
      this.getHeader()
    );
  }


  createHousingListing(data) {
    let options = this.xAccessToeknHeader();

    return this.http.post(
      `${environment.baseUrl}/addHousingPost`,
      data,
      options
    );
  }

 updateHousingPost(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/updateHousingPost`,
      data,
      options
    );
  }
  deleteHousing(id) {
    return this.http.delete(
      `${environment.baseUrl}/community/deleteEvent/${id}`,
      this.getHeader()
    );
  }
  getMyHousingPosts() {
    let options = this.xAccessToeknHeader();
    return this.http.get(
      `${environment.baseUrl}/getMyHousingPosts`,
      options
    );
  }
  createJob(data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/jobPost`,
      data,
      options
    );
  }

  getJobPosts() {
    let options = this.xAccessToeknHeader();
    return this.http.post(
      `${environment.baseUrl}/jobPosts`,
      {},
      options
    );
  }

  updateJob(id: string, data: any) {
    let options = this.xAccessToeknHeader();
    return this.http.put(
      `${environment.baseUrl}/jobPost/${id}`,
      data,
      options
    );
  }

  //payout apis 

  getStripeStatus() {
  return this.http.get(
    `${environment.baseUrl}/community/stripe-status`,
    this.getHeader()
  );
}

connectStripeAccount() {
  return this.http.get(
    `${environment.baseUrl}/community/connect-bank-account`,
    this.getHeader()
  );
}


}
